export default __webpack_public_path__ + "static/media/mountains.bfd60073.jpg";